import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource'

class OrganizationAgentImportAppResource extends AppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'organization-agent-import';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'organizations/agents/imports';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'uuid',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'userEmail'
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {};
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return [];
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            userEmail: {
                type: 'string'
            }
        };
    }

}

export default OrganizationAgentImportAppResource;
